import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import { withRouter } from "react-router";
import classnames from "classnames";
import { Button } from "@lifepay/rc-ui-toolkit";

import styles from "./Company.m.scss";

function Company(props) {
  const {
    theme,
    item,
    // selectedCompany,
    // selectCompany,
    goToMerchants,
    goToTerminals,
    goToTransactions,
  } = props;
  return (
    <div
      className={classnames(
        theme.wrapper
        // selectedCompany && selectedCompany.id === item.id && theme.active
      )}
      // onClick={() => selectCompany(item)}
    >
      <div>{item.id}</div>
      <div>{item.companyName || "-"}</div>
      <div>{item.companyFullName || "-"}</div>
      <div>{item.inn || "-"}</div>
      <div>
        <Button
          theme={{ wrapper: theme.button }}
          size={"small"}
          type={"alt"}
          onClick={() =>
            goToMerchants({
              search: `?company-id=${item.id}`,
              state: {
                routerStateQuery: {
                  companyId: item.id,
                },
              },
            })
          }
        >
          {"Точки обслуживания"}
        </Button>
      </div>
      <div>
        <Button
          theme={{ wrapper: theme.button }}
          size={"small"}
          type={"alt"}
          onClick={() =>
            goToTerminals({
              search: `?company-id=${item.id}`,
              state: {
                routerStateQuery: {
                  companyId: item.id,
                },
              },
            })
          }
        >
          {"Терминалы"}
        </Button>
      </div>
      <div>
        <Button
          theme={{ wrapper: theme.button }}
          size={"small"}
          type={"alt"}
          onClick={() =>
            goToTransactions({
              search: `?company-id=${item.id}`,
              state: {
                routerStateQuery: {
                  companyId: item.id,
                },
              },
            })
          }
        >
          {"Транзакции"}
        </Button>
      </div>
    </div>
  );
}

Company.displayName = "Company";

Company.propTypes = {
  theme: PropTypes.object,
  history: PropTypes.object,
  item: PropTypes.object.isRequired,
  selectedCompany: PropTypes.object,
  selectCompany: PropTypes.func,
  goToMerchants: PropTypes.func,
  goToTerminals: PropTypes.func,
  goToTransactions: PropTypes.func,
};

Company.defaultProps = {};

export default withRouter(themr("@lifepay/Company", styles)(Company));



// WEBPACK FOOTER //
// ./src/components/list-items/compact/Company/Company.js